<div class="card mb-3">
  <div class="card-body">

    <div class="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-3">
      <div>
        <h5 class="mt-0 mb-1">
          <i class="ri-git-branch-line me-1 text-primary"></i>
          {{ 'channel.health.hybrid.title' | translate }}
        </h5>
        @if (usage) {
          <p class="text-muted small mb-0">{{ 'channel.health.hybrid.subtitle' | translate: { month: usage.month } }}</p>
        }
      </div>
      @if (!paired) {
        <span class="badge bg-soft-secondary text-secondary">{{ 'channel.hybridSession.notPaired' | translate }}</span>
      } @else {
        <span class="badge" [ngClass]="connected ? 'bg-soft-success text-success' : 'bg-soft-danger text-danger'">
          <i class="mdi me-1" [ngClass]="connected ? 'mdi-link-variant' : 'mdi-link-variant-off'"></i>
          {{ (connected ? 'channel.hybridSession.connected' : 'channel.hybridSession.disconnected') | translate }}
        </span>
      }
    </div>

    @if (mismatch) {
      <div class="alert alert-danger py-2" role="alert">
        <i class="ri-error-warning-line me-1"></i>
        {{ 'channel.hybridSession.mismatchAlert' | translate }}
      </div>
    }

    @if (paired) {
      <p class="text-muted small">
        {{ 'channel.hybridSession.lastSeen' | translate }}:
        {{ channel?.hybridConfig?.sessionLastSeenAt ? (channel.hybridConfig.sessionLastSeenAt | date: 'dd/MM/yyyy HH:mm') : '—' }}
      </p>
    }

    @if (loadingContent) {
      <div class="d-flex justify-content-center py-3">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'dashboard.dashboard.loading' | translate }}</span>
        </div>
      </div>
    }

    @if (!loadingContent && failed) {
      <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
        <span class="text-muted">{{ 'channel.health.hybrid.unavailable' | translate }}</span>
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="load()">
          <i class="ri-refresh-line me-1"></i>
          {{ 'attendance.copilot.retry' | translate }}
        </button>
      </div>
    }

    @if (!loadingContent && !failed && usage) {
      <div class="row g-3">
        <div class="col-lg-6">
          <div class="d-flex justify-content-between small mb-1">
            <span>{{ 'channel.health.hybrid.official' | translate }}: <strong>{{ usage.outbound.official }}</strong></span>
            <span>{{ 'channel.health.hybrid.session' | translate }}: <strong>{{ usage.outbound.session }}</strong></span>
          </div>
          <div class="progress" role="progressbar" [attr.aria-valuenow]="sessionPercent()" aria-valuemin="0" aria-valuemax="100">
            <div class="progress-bar bg-success" [style.width.%]="officialPercent()"></div>
            <div class="progress-bar bg-info" [style.width.%]="sessionPercent()"></div>
          </div>

          <dl class="row small mt-3 mb-0">
            <dt class="col-7">{{ 'channel.health.hybrid.configuredShare' | translate }}</dt>
            <dd class="col-5 text-end">{{ usage.configuredShare }}%</dd>
            <dt class="col-7">{{ 'channel.health.hybrid.effectiveShare' | translate }}</dt>
            <dd class="col-5 text-end">{{ usage.effectiveShare != null ? (usage.effectiveShare + '%') : '—' }}</dd>
            <dt class="col-7">{{ 'channel.health.hybrid.fallbacks' | translate }}</dt>
            <dd class="col-5 text-end">{{ usage.freeForm.fallback }}</dd>
            <dt class="col-7">{{ 'channel.health.hybrid.templates' | translate }}</dt>
            <dd class="col-5 text-end">{{ usage.templates }}</dd>
          </dl>
        </div>

        <div class="col-lg-6">
          <div class="border rounded p-3 h-100">
            <p class="text-muted small mb-1">{{ 'channel.health.hybrid.estimatedSaving' | translate }}</p>
            <h3 class="mt-0 mb-2">{{ usage.estimatedSavingUSD | currency: 'USD' : 'symbol' : '1.2-2' }}</h3>
            <p class="text-muted small mb-0">
              {{ rateNoteKey() | translate: { rate: (usage.rateUSD | number: '1.4-4') } }}
            </p>
          </div>
        </div>
      </div>
    }
  </div>
</div>
